import React from 'react'
import { useTranslation } from 'react-i18next'

import { Caption1 } from '@ui/Typography'
import { Tooltip } from '@ui/components/Tooltip'
import { InfoIcon } from '@ui/icons/Info.icon'
import { WarningIcon } from '@ui/icons/Warning.icon'

import styles from './LowMarginAlert.module.scss'

type LowMarginAlertProps = {
  onDeposit: () => void
  className?: string
}

export const LowMarginAlert = ({ onDeposit }: LowMarginAlertProps) => {
  const { t } = useTranslation()

  return (
    <div className={styles.lowMarginMobileAlert}>
      <WarningIcon size={16} color='text-warning-high-em' />
      <Caption1 medium color='text-warning-high-em'>
        {t('Markets.Low Margin Level')}
      </Caption1>
      <Tooltip
        heading={t('Markets.Low Margin Level Title')}
        description={t('Markets.Low Margin Level Description')}
        primaryButton={{
          label: t('Add funds'),
          onClick: onDeposit,
        }}
        secondaryButton={{ label: t('Cancel') }}
        direction='top'
      >
        <InfoIcon size={16} color='text-warning-high-em' />
      </Tooltip>
    </div>
  )
}
